///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserDTO } from '../../generated/shared-types.model';

@Injectable({ providedIn: 'root' })
export class AccountService {
    constructor(private readonly http: HttpClient) {}

    get(): Observable<UserDTO> {
        return this.http.get<UserDTO>('api/account');
    }

    save(account: UserDTO): Observable<any> {
        return this.http.post('api/account', account).pipe(catchError(() => of({} as UserDTO)));
    }
}
